/**
 * Declaration Service
 * Handles POA and Declaration API operations for trademark applications
 */
import api from './index';

/**
 * Get declaration by application ID
 * @param {string} applicationId - The application ID
 * @returns {object|null} Declaration data or null if not found
 */
async function getDeclarationByApplication(applicationId) {
  if (!applicationId) {
    throw new Error('Application ID is required');
  }

  try {
    const response = await api.get('/declaration', {
      params: { applicationId }
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
}

/**
 * Save declaration (POA + Declaration signatures)
 * @param {string} applicationId - The application ID
 * @param {object} data - Declaration data including signatures
 * @returns {object} Saved declaration data
 */
async function saveDeclaration(applicationId, data) {
  if (!applicationId) {
    throw new Error('Application ID is required');
  }

  // Send data flat with applicationId
  const response = await api.post('/declaration', {
    id: data.id, // Pass through for updates
    applicationId,
    ...data
  });

  return response.data;
}

export const declarationService = {
  /**
   * Get declaration for an application
   */
  getByApplication: getDeclarationByApplication,
  
  /**
   * Save declaration (creates or updates)
   */
  save: saveDeclaration,
  
  /**
   * Alias for save
   */
  saveDeclaration,
};

export default declarationService;
